/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
// @ts-ignore
import DropNCrop from '@synapsestudios/react-drop-n-crop';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import UploadContents from './containers/UploadContents/UploadContents';
import UploadControls from './containers/UploadControls/UploadControls';
import { IFile, IUploadProps } from './types';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { makeBlob } from 'src/utils/helpers';
import logger from '~/services/logger';
import './style.scss';

interface IState {
  error: string | null;
  filename?: string;
  filetype?: string;
  result?: string;
  src?: string;
  //
  crop: any;
  //
  loading: boolean;
  timer: number; // validation block hiding time
  validBlock: boolean; // visible validation block
}

export default class Upload extends React.Component<IUploadProps, IState> {
  static defaultProps = {
    image: '',
    //
    validTimerDuration: 5000,
    className: '',
  };

  validErrorHideVisibleTimer: NodeJS.Timeout | null = null;
  validErrorHideVisibleCounter: NodeJS.Timeout | null = null;

  state: IState = {
    error: null,
    filename: undefined,
    filetype: undefined,
    result: undefined,
    src: undefined,
    //
    crop: null,
    //
    loading: false,
    timer: 0,
    validBlock: false,
  };

  onChange = (file: IFile) => {
    if (file.error) {
      this.setState({ validBlock: true, timer: this.props.validTimerDuration / 1000 }, this.hideValidBlock);
    }

    this.setState(file);
    if (this.props.onChange) this.props.onChange(file);
  };

  onReset = () => {
    this.setState({ error: null, filename: undefined, filetype: undefined, result: undefined, src: undefined }, () => {
      if (this.props.onChange) this.props.onChange(this.file);
    });
  };

  hideValidBlock = () => {
    if (this.validErrorHideVisibleTimer) {
      clearTimeout(this.validErrorHideVisibleTimer);
      if (this.validErrorHideVisibleCounter) clearInterval(this.validErrorHideVisibleCounter);
    }
    this.validErrorHideVisibleCounter = setInterval(() => this.setState({ timer: this.state.timer - 1 }), 1000);
    this.validErrorHideVisibleTimer = setTimeout(this.timerCallback, this.props.validTimerDuration);
  };
  timerCallback = () => {
    if (this.props.image) {
      this.setState({ validBlock: false }, () => {
        if (this.validErrorHideVisibleCounter) clearInterval(this.validErrorHideVisibleCounter);
        if (this.props.onChange) this.props.onChange(this.file);
      });
    } else {
      this.setState({ validBlock: false, error: null, filename: undefined, filetype: undefined, result: undefined, src: undefined }, () => {
        if (this.validErrorHideVisibleCounter) clearInterval(this.validErrorHideVisibleCounter);
        if (this.props.onChange) this.props.onChange(this.file);
      });
    }
  };
  resetTimer = () => {
    if (this.props.image) {
      this.setState({ validBlock: false, timer: 0 }, () => {
        if (this.props.onChange) this.props.onChange(this.file);
      });
    } else {
      this.setState({ validBlock: false, timer: 0, error: null, filename: undefined, filetype: undefined, result: undefined, src: undefined }, () => {
        if (this.props.onChange) this.props.onChange(this.file);
      });
    }

    if (this.validErrorHideVisibleTimer) clearTimeout(this.validErrorHideVisibleTimer);
    if (this.validErrorHideVisibleCounter) clearInterval(this.validErrorHideVisibleCounter);
  };

  formDataAppend = () => {
    if (!this.state.result) return;

    const formData = new FormData();
    // @ts-ignore
    formData.append(this.props.customType || 'image', makeBlob(this.state.result));
    this.uploadFile(formData);
  };

  uploadFile = async (formData: any) => {
    try {
      this.setState({ loading: true });

      const response = await client.post(this.props.apiUrl || '/v3/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: {
          type: this.props.type,
          ...this.props.params,
        },
      });

      this.props.changeFile(response[this.props.customType || 'image']);
      this.setState({ error: null, filename: undefined, filetype: undefined, result: undefined, src: undefined, loading: false });
    } catch (error: any) {
      this.setState({ loading: false });
      logger.error({ error, place: 'Upload uploadFile', showModal: true, modalProps: { title: localeStore.t('file_upload_failed') } });
    }
  };

  get file(): IFile {
    return {
      error: this.state.error,
      filename: this.state.filename,
      filetype: this.state.filetype,
      result: this.state.result,
      src: this.state.src,
    };
  }

  render() {
    return (
      <div className={`upload ${this.props.className || ''}`}>
        {!this.props.disabled ? (
          <DropNCrop
            value={this.state}
            onChange={this.onChange}
            allowedFileTypes={this.props.allowedFileTypes}
            maxFileSize={this.props.maxFileSize}
            cropperOptions={{
              initialAspectRatio: this.props.initialAspectRatio,
              aspectRatio: this.props.aspectRatio,
              guides: true, // Show the dashed lines above the crop box.
              responsive: true, // Re-render the cropper when resizing the window.
              center: true,
              viewMode: 1, // restrict the crop box not to exceed the size of the canvas.
              autoCrop: true, // Enable to crop the image automatically when initialized.
              autoCropArea: 1,
              destroy: this.state.crop, // Destroy the cropper and remove the instance from the image.
            }}
          />
        ) : null}

        <UploadControls fileName={this.state.filename} loading={this.state.loading} onReset={this.onReset} formDataAppend={this.formDataAppend} />
        <UploadContents {...this.props} {...this.state} resetTimer={this.resetTimer} />

        {this.props.image && !this.state.result && !this.state.validBlock ? (
          <img className="upload__background" src={this.props.image} alt="preview_image" />
        ) : null}

        <LoadingOverlay visible={this.state.loading} className="upload__overlay" />
      </div>
    );
  }
}
